import * as React from 'react';

import Head from 'next/head';

import { GlobalDatingTrendsContentSwitchContainer } from 'containers/global-dating-trends/global-dating-trends-content-switch-container';
import { GlobalDatingTrendsHeroBlockContainer } from 'containers/global-dating-trends/global-dating-trends-hero-block-container';
import { GlobalDatingTrendsInfographicContainer } from 'containers/global-dating-trends/global-dating-trends-infographic-block-container';
import { PageContainer } from 'containers/page/page-container';
import { FooterContainer } from 'containers/project-love/common/app/footer-container';
import { HeaderContainer } from 'containers/project-love/common/app/header-container';

type GlobalDatingTrendsContainerProps = {
  lang?: string;
  title?: string;
  description?: string;
  lexemes?: string[];
};

export const GlobalDatingTrendsContainer: React.FC = (props: GlobalDatingTrendsContainerProps) => {
  return (
    <PageContainer>
      <Head>
        <title>{props.title}</title>
        <meta name="description" property="description" content={props.description} />
      </Head>
      <HeaderContainer />
      <main id="main" tabIndex={-1}>
        <GlobalDatingTrendsHeroBlockContainer title={props.title} />
        <GlobalDatingTrendsContentSwitchContainer lang={props.lang} />
        <GlobalDatingTrendsInfographicContainer
          lang={props.lang}
          title={props.title}
          lexemes={props.lexemes}
        />
      </main>
      <FooterContainer hideLanguageSelector={true} />
    </PageContainer>
  );
};
